module.exports = __webpack_public_path__ + "media/images/swifticons/genericusercircle-8d2418314bc80ce61573326a1a4cd7b6.svg";